import React, { useContext } from 'react'

import { Column } from '@vividseats/vivid-ui-kit'

import Article from '@/components/shared/article'
import { CMSProvider } from '@/context/cms'
import ProductionDetailsContext from '@/context/production-details'

const CMSContent: React.FC = () => {
    const {
        selectors: { productionDetails },
    } = useContext(ProductionDetailsContext)

    return (
        <Column noFlex pt={1.5}>
            <div data-testid="cms-content">
                <CMSProvider article={productionDetails?.article}>
                    <Article />
                </CMSProvider>
            </div>
        </Column>
    )
}

export default CMSContent
